module.exports = __webpack_public_path__ + "img/30.a9f09e3.jpg";